import { render, staticRenderFns } from "./IhaPagination.vue?vue&type=template&id=5c523666&"
import script from "./IhaPagination.vue?vue&type=script&lang=js&"
export * from "./IhaPagination.vue?vue&type=script&lang=js&"
import style0 from "./IhaPagination.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports